/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DeliveryFeeRequest } from '../model';
// @ts-ignore
import { DeliveryFeeResponse } from '../model';
// @ts-ignore
import { PagedResponseDeliveryFeeResponse } from '../model';
/**
 * AdminDeliveryFeeControllerApi - axios parameter creator
 * @export
 */
export const AdminDeliveryFeeControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DeliveryFeeRequest} deliveryFeeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeliveryFee: async (deliveryFeeRequest: DeliveryFeeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deliveryFeeRequest' is not null or undefined
            assertParamExists('createDeliveryFee', 'deliveryFeeRequest', deliveryFeeRequest)
            const localVarPath = `/admin/delivery-fees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deliveryFeeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} deliveryFeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeliveryFee: async (deliveryFeeId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deliveryFeeId' is not null or undefined
            assertParamExists('deleteDeliveryFee', 'deliveryFeeId', deliveryFeeId)
            const localVarPath = `/admin/delivery-fees/{deliveryFeeId}`
                .replace(`{${"deliveryFeeId"}}`, encodeURIComponent(String(deliveryFeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} deliveryFeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryFee: async (deliveryFeeId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deliveryFeeId' is not null or undefined
            assertParamExists('getDeliveryFee', 'deliveryFeeId', deliveryFeeId)
            const localVarPath = `/admin/delivery-fees/{deliveryFeeId}`
                .replace(`{${"deliveryFeeId"}}`, encodeURIComponent(String(deliveryFeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [area] 
         * @param {number} [zone] 
         * @param {string} [planId] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDeliveryFees: async (area?: string, zone?: number, planId?: string, page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/delivery-fees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (area !== undefined) {
                localVarQueryParameter['area'] = area;
            }

            if (zone !== undefined) {
                localVarQueryParameter['zone'] = zone;
            }

            if (planId !== undefined) {
                localVarQueryParameter['planId'] = planId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} deliveryFeeId 
         * @param {DeliveryFeeRequest} deliveryFeeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeliveryFee: async (deliveryFeeId: string, deliveryFeeRequest: DeliveryFeeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deliveryFeeId' is not null or undefined
            assertParamExists('updateDeliveryFee', 'deliveryFeeId', deliveryFeeId)
            // verify required parameter 'deliveryFeeRequest' is not null or undefined
            assertParamExists('updateDeliveryFee', 'deliveryFeeRequest', deliveryFeeRequest)
            const localVarPath = `/admin/delivery-fees/{deliveryFeeId}`
                .replace(`{${"deliveryFeeId"}}`, encodeURIComponent(String(deliveryFeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deliveryFeeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminDeliveryFeeControllerApi - functional programming interface
 * @export
 */
export const AdminDeliveryFeeControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminDeliveryFeeControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {DeliveryFeeRequest} deliveryFeeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDeliveryFee(deliveryFeeRequest: DeliveryFeeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryFeeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDeliveryFee(deliveryFeeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} deliveryFeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDeliveryFee(deliveryFeeId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDeliveryFee(deliveryFeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} deliveryFeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeliveryFee(deliveryFeeId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryFeeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeliveryFee(deliveryFeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [area] 
         * @param {number} [zone] 
         * @param {string} [planId] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDeliveryFees(area?: string, zone?: number, planId?: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResponseDeliveryFeeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDeliveryFees(area, zone, planId, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} deliveryFeeId 
         * @param {DeliveryFeeRequest} deliveryFeeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDeliveryFee(deliveryFeeId: string, deliveryFeeRequest: DeliveryFeeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDeliveryFee(deliveryFeeId, deliveryFeeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminDeliveryFeeControllerApi - factory interface
 * @export
 */
export const AdminDeliveryFeeControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminDeliveryFeeControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {DeliveryFeeRequest} deliveryFeeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeliveryFee(deliveryFeeRequest: DeliveryFeeRequest, options?: any): AxiosPromise<DeliveryFeeResponse> {
            return localVarFp.createDeliveryFee(deliveryFeeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} deliveryFeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeliveryFee(deliveryFeeId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteDeliveryFee(deliveryFeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} deliveryFeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryFee(deliveryFeeId: string, options?: any): AxiosPromise<DeliveryFeeResponse> {
            return localVarFp.getDeliveryFee(deliveryFeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [area] 
         * @param {number} [zone] 
         * @param {string} [planId] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDeliveryFees(area?: string, zone?: number, planId?: string, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PagedResponseDeliveryFeeResponse> {
            return localVarFp.listDeliveryFees(area, zone, planId, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} deliveryFeeId 
         * @param {DeliveryFeeRequest} deliveryFeeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeliveryFee(deliveryFeeId: string, deliveryFeeRequest: DeliveryFeeRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateDeliveryFee(deliveryFeeId, deliveryFeeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminDeliveryFeeControllerApi - object-oriented interface
 * @export
 * @class AdminDeliveryFeeControllerApi
 * @extends {BaseAPI}
 */
export class AdminDeliveryFeeControllerApi extends BaseAPI {
    /**
     * 
     * @param {DeliveryFeeRequest} deliveryFeeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDeliveryFeeControllerApi
     */
    public createDeliveryFee(deliveryFeeRequest: DeliveryFeeRequest, options?: AxiosRequestConfig) {
        return AdminDeliveryFeeControllerApiFp(this.configuration).createDeliveryFee(deliveryFeeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} deliveryFeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDeliveryFeeControllerApi
     */
    public deleteDeliveryFee(deliveryFeeId: string, options?: AxiosRequestConfig) {
        return AdminDeliveryFeeControllerApiFp(this.configuration).deleteDeliveryFee(deliveryFeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} deliveryFeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDeliveryFeeControllerApi
     */
    public getDeliveryFee(deliveryFeeId: string, options?: AxiosRequestConfig) {
        return AdminDeliveryFeeControllerApiFp(this.configuration).getDeliveryFee(deliveryFeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [area] 
     * @param {number} [zone] 
     * @param {string} [planId] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDeliveryFeeControllerApi
     */
    public listDeliveryFees(area?: string, zone?: number, planId?: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return AdminDeliveryFeeControllerApiFp(this.configuration).listDeliveryFees(area, zone, planId, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} deliveryFeeId 
     * @param {DeliveryFeeRequest} deliveryFeeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDeliveryFeeControllerApi
     */
    public updateDeliveryFee(deliveryFeeId: string, deliveryFeeRequest: DeliveryFeeRequest, options?: AxiosRequestConfig) {
        return AdminDeliveryFeeControllerApiFp(this.configuration).updateDeliveryFee(deliveryFeeId, deliveryFeeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

